// test636
(636 && 0);
